// Sentinel id used for the placeholder shippingOption Google Pay renders while
// the real methods have not yet loaded (guest STH: no default address yet, so
// Cart Service returns an empty method list on paysheet open). Distinctive
// multi-word slug so it cannot collide with a real Cart Service methodId
// (which are numeric-looking strings like '1', '300014', '800100' etc).
// Consumed by utils/GooglePay (`getShippingOptionParametersOrPlaceholder`) and
// utils/GooglePayHandlers (`handleShippingOptionChange` short-circuit) — kept
// here to avoid a cyclic import between those two modules.
export const PLACEHOLDER_SHIPPING_OPTION_ID = 'placeholder-shipping-option';

export const GOOGLE_PAY_LEGAL_LINKS = {
    terms: {
        us: 'https://support.google.com/googlepay/answer/9039712?hl=en',
        caEn: 'https://support.google.com/googlepay/answer/9039712?hl=en',
        caFr: 'https://support.google.com/googlepay/answer/9039712?hl=fr'
    },
    privacy: {
        us: 'https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice',
        caEn: 'https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice',
        caFr: 'https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice&ldl=fr-CA'
    }
};
